import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from './ui/button';

const COOKIE_CONSENT_KEY = 'sinticket_cookie_consent';

const CookieConsent: React.FC = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify({
      necessary: true,
      analytics: true,
      timestamp: new Date().toISOString(),
    }));
    setVisible(false);
  };

  const reject = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify({
      necessary: true,
      analytics: false,
      timestamp: new Date().toISOString(),
    }));
    setVisible(false);
  };

  // Painel TV não tem ninguém para clicar no banner
  if (!visible || window.location.pathname.startsWith('/painel-tv')) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6">
      <div className="max-w-4xl mx-auto bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 rounded-lg shadow-2xl p-6">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
              {t('cookieConsent.title')}
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              {t('cookieConsent.textBefore')}{' '}
              <a href="/politica-de-privacidade" className="underline text-blue-600 dark:text-blue-400">
                {t('cookieConsent.privacyLink')}
              </a>{' '}
              {t('cookieConsent.textAfter')}
            </p>
          </div>
          <div className="flex items-center gap-3 shrink-0">
            <Button
              variant="outline"
              onClick={reject}
              className="text-gray-600 dark:text-gray-400 border-gray-300 dark:border-slate-600"
            >
              {t('cookieConsent.essentialOnly')}
            </Button>
            <Button
              onClick={accept}
              className="bg-green-600 hover:bg-green-700 text-white"
            >
              {t('cookieConsent.acceptAll')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
